import { FC, memo } from 'react';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteDomainRegistrarQuery } from '@/modules/DomainRegistrars';

interface Props extends AppAutocompleteComponentProps {}

export const DomainRegistrarsAllAutocomplete: FC<Props> = memo((props) => {
  return (
    <AppAutocomplete<typeof useAutocompleteDomainRegistrarQuery>
      { ...props }
      options={
        (data) =>
          parseSelectData(data, {
            value: 'id',
            label: 'name'
          })
      }
      notFoundDescription="Немає реєстраторів доменів"
      placeholder="Знайдіть реєстратор доменів"
      query={ useAutocompleteDomainRegistrarQuery }
    />
  );
});
